export default __webpack_public_path__ + "b46a62f.png";